/**
 * Documents feature auto-registration and exports
 *
 * This module automatically registers the documents feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { documentsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(documentsFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';

// Export hooks
export * from './hooks';

// Export components
export * from './components';

// Export page components
export { SentDocumentsPage } from './components/SentDocumentsPage';
export { DocumentTemplatesPage } from './components/DocumentTemplatesPage';
export { FormsPage } from './components/FormsPage';
export { LabsPage } from './components/LabsPage';
export { DocumentsPage } from './DocumentsPage';

